module.exports = __webpack_public_path__ + "static/media/emojis2_11.4127d2c6.svg";